import { render } from "./PluginInfo.vue?vue&type=template&id=9d8437ba&scoped=true&ts=true"
import script from "./PluginInfo.vue?vue&type=script&lang=ts"
export * from "./PluginInfo.vue?vue&type=script&lang=ts"

import "./PluginInfo.vue?vue&type=style&index=0&id=9d8437ba&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d8437ba"]])

export default __exports__